module.exports = __webpack_public_path__ + "img/27.39565499.jpg";